import React, { useState } from 'react'
import './login.less'
import PasswordForm from './password_form'
import PhoneForm from './phone_form'
import CommonFooter from '../CommonFooter'
import { useHistory } from 'react-router-dom'

const loginTypes = {
  phone: 'phone',
  password: 'password',
}

const Login = () => {
  const [loginType, setLoginType] = useState(loginTypes.password)
  const history = useHistory()
  return (
    <>
      <div className='wrap'>
        <div className="wrap-mask" style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/login-bg.png)`
        }}>
          <div className='logo'>
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt='logo' />
          </div>
          <div onClick={() => history.push('/')} className='btn-to-home'>回到主页</div>
          <div className='login-card'>
            <div className='login-card-image'>
              <img src={`${process.env.PUBLIC_URL}/images/login-card.png`} alt='login-card' />
            </div>
            <div className='login-card-content'>
              <div className='login-form-title'>
                <img src={`${process.env.PUBLIC_URL}/images/login-form-logo.png`} alt='logo'/>
              </div>
              <div className='login-form-type-outer'>
                <div
                  className={`login-form-type ${loginType === loginTypes.password ? 'login-form-type-active bold' : ''
                    }`}
                  onClick={() => setLoginType(loginTypes.password)}
                >
                  <div>
                    账号登录
                  </div>
                </div>
                <div
                  className={`login-form-type ${loginType === loginTypes.phone ? 'login-form-type-active bold' : ''
                    }`}
                  onClick={() => setLoginType(loginTypes.phone)}
                >
                  <div>
                    手机号登录
                  </div>
                </div>
              </div>
              {
                loginType === loginTypes.password ? <PasswordForm /> : <PhoneForm />
              }
            </div>
          </div>
          <div className='footer-container'>
            <CommonFooter color='blue'/>
      </div>
        </div>
      </div>
    </>
  )
}

export default Login
